﻿import React, { useState, useEffect } from 'react';
import { UserDataStore } from '../store/userDataStore';
import { BenchSheetTechnologyType, NoteType, Entities } from '../models/enums';
import { TurbidityBenchSheet } from '../models/turbidity-bench-sheet';
import { SpotCheckBenchSheet } from '../models/spot-check-bench-sheet';
import MeasuredData from './MeasuredData';
import SecondaryBenchSheetInstrument from './SecondaryBenchSheetInstrument';
import BenchSheetHeaderComponent from './BenchSheetHeaderComponent';
import NoteViewer from './NoteViewer';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { ItemBasicInformation } from '../models/item-basic-information';
import { DocumentationConstants } from '../store/documentation-constants';
import TicketLogEntryForm from './TicketLogEntryForm';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import BenchSheetToolbar from './BenchSheetToolbar';
import { FieldUpdate } from '../models/field-update';
import { CrudFunctions } from '../utilities/crud-functions';
import DmaFooter from './DmaFooter';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';

//temp
const methodTypes = [
    { id: 1, name: "Manual" },
    { id: 2, name: "Sipper" },
    { id: 3, name: "Manual + Sipper" }
];

let key = 1;

export default function TurbidityBenchSheetForm() {
    const [canEdit, setCanEdit] =
        useState<boolean>(false);

    const [benchSheet, setBenchSheet] =
        useState<TurbidityBenchSheet>();

    const [spotCheckBenchSheets, setSpotCheckBenchSheets] =
        useState<SpotCheckBenchSheet[]>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>(false);

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [currentTab, setCurrentTab] =
        useState<string>();

    //const [initTabsComplete, setInitTabsComplete] =
    //  useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        setAuthorizations();
        getAllData();
    }, []);

    useEffect(() => {
        initTabs();
    }, [spotCheckBenchSheets]);

    /*
    useEffect(() => {
        if(!initTabsComplete)
            initTabs(); 
    }, [spotCheckBenchSheets]);
    */

    const parts = window.location.href.split('/');
    const benchSheetId = parts[parts.length - 1];

    const spotChecks = () => {
        if (!spotCheckBenchSheets)
            return null;

        let sc = spotCheckBenchSheets.map(s => s.sequence);

        return sc;
    }

    key++;

    return (
        <div className="pw-form-container">
            <div className="pw-content">
                <BenchSheetToolbar title="Turbidity Bench Sheet"
                    subtitle="Turbidity"
                    auditRowPointer={benchSheetId} entity={Entities.TurbidityBenchSheets}
                    technologyId={BenchSheetTechnologyType.Turbidity}
                    documentationId={DocumentationConstants.TURBBenchSheets}
                    showItemInformation={showBenchSheetInformationDialog}
                    showTicketLog={showTicketLogEntryDialog} />

                <BenchSheetHeaderComponent benchSheetId={benchSheetId} readOnly={!canEdit} />

                <div className="pw-comp-row">
                    <div className="pw-row-button-08">
                        <Button id="addSpotCheckButton" disabled={!canEdit}
                            text="Add Spot Check" type="success"
                            hint="add spot checks"
                            onClick={onAddSpotCheckClick} />
                    </div>

                    <div className="pw-row-button-08 pw-margin-left-05">
                        <Button id="removeSpotCheckButton" disabled={!canEdit}
                            text="Remove Spot Check" type="normal"
                            hint="remove spot checks"
                            onClick={onRemoveSpotCheckClick} />
                    </div>
                </div>

                <div id="pb-navigation-pane" >
                    <div id="tab-buttons-panel" className="tab-buttons-container">
                        <div id="qcPanelButton" onClick={onPanelButtonClick}>QC</div>

                        {spotCheckBenchSheets && spotCheckBenchSheets.map((item, i) =>
                            <div key={i.toString()} id={`spotCheckPanelButton${item.sequence}`} onClick={onPanelButtonClick}>{`Spot Check ${item.sequence}`}</div>)}

                    </div>
                </div>

                <div id="qcPanel" className="pw-form-section">
                    <SecondaryBenchSheetInstrument benchSheetId={benchSheetId} isReadOnly={!canEdit}
                        title="Turbidity Instrument" technology={BenchSheetTechnologyType.Turbidity} />

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Method</div>
                            <SelectBox id="methodId"
                                className="selectbox"
                                placeholder='NA' readOnly={!canEdit}
                                displayExpr='name' valueExpr='id'
                                dataSource={methodTypes ? methodTypes : []}
                                onValueChanged={onValueChanged}
                                value={benchSheet && benchSheet.methodId ?
                                    benchSheet.methodId : null} />
                        </div>
                    </div>

                    <div className="pw-comp-row-scroll-fixed-grid">
                        <MeasuredData benchSheetId={benchSheetId} readOnly={!canEdit}
                            datagridHeight={'30em'} isReadOnly={false}
                            showSipperMeasuredValue={true} />
                    </div>

                </div>

                <div>{spotCheckBenchSheets && spotCheckBenchSheets.map((item, i) =>
                    <div id={`spotCheckPanel${item.sequence}`} key={i.toString()} className="pw-form-section">
                        <div className="pw-form-unit lq-sub-title pw-margin-top-05 pw-margin-bottom-05">{`Spot Check #${item.sequence}`}</div>

                        <SecondaryBenchSheetInstrument benchSheetId={benchSheetId} isReadOnly={!canEdit}
                            spotCheckBenchSheetId={item.spotCheckBenchSheetId}
                            title="Turbidity Instrument" technology={BenchSheetTechnologyType.Turbidity} />

                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-20">
                                <div className="pw-form-unit-label">Method</div>
                                <SelectBox id={`methodId_${item.sequence}`}
                                    className="selectbox"
                                    placeholder='NA' readOnly={!canEdit}
                                    displayExpr='name' valueExpr='id'
                                    dataSource={methodTypes ? methodTypes : []}
                                    onValueChanged={onSpotCheckValueChanged}
                                    value={item.methodId ? item.methodId : null} />
                            </div>
                        </div>

                        <div className="pw-comp-row-scroll-fixed-grid">
                            <MeasuredData benchSheetId={benchSheetId} readOnly={!canEdit}
                                spotCheckBenchSheetId={item.spotCheckBenchSheetId}
                                showSipperMeasuredValue={true}
                                datagridHeight={'30em'}
                                isReadOnly={false} />
                        </div>
                    </div>
                )}
                </div>


                {/*
                <CalibrationLogbook benchSheetId={benchSheetId} />

                <SamplePreparationsDataComponent height="20rem" benchSheetId={benchSheetId}
                    productId={benchSheet && benchSheet.productId ? benchSheet.productId : undefined}
                    productName={benchSheet && benchSheet.productCatalogNumber ? benchSheet.productCatalogNumber : undefined}
                    batchId={benchSheet && benchSheet.batchId ? benchSheet.batchId : undefined}
                    batchName={benchSheet && benchSheet.batchName ? benchSheet.batchName : undefined} />

                <div className="pw-comp-row-scroll-fixed-grid">
                    <AnalysisDataData
                        benchSheetId={benchSheetId ? benchSheetId : undefined}
                        batchId={benchSheet && benchSheet.batchId ?
                            benchSheet.batchId : undefined}
                        isReadOnly={!canEdit}
                        datagridHeight={'30em'} />
                </div>
                */}

                <div className="pw-comp-row-scroll-fixed-grid">
                    <NoteViewer height='10rem' title="Bench Sheet Note"
                        noteType={NoteType.Method} parentId={benchSheetId} />
                </div>

            </div>

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Conductivity Bench Sheet" contextData={benchSheet}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function setAuthorizations() {
        const user = UserDataStore.getCurrentUser();

        const canEditRoles = ["SA", "MF-A", "MF-L", "MF-T", "PP-A", "PP-L", "PP-T", "DIST-A", "BA-A", "QCP-A", "QCD-A", "RD-A", "RD-L", "RD-T"];
        const canEdit = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));

        setCanEdit(canEdit);
    }

    async function onAddSpotCheckClick() {
        const spotCheckCount = spotChecks && spotChecks.length > 0 ? spotChecks.length : 0;

        const newSpotCheckBenchSheet: SpotCheckBenchSheet = {
            benchSheetId: benchSheetId,
            sequence: spotCheckCount + 1,
        };

        await insertSpotCheckBenchSheet(newSpotCheckBenchSheet)
            .then(() => {

                getSpotCheckBenchSheets();
                /*
                let newSpotChecks = spotChecks ? [...spotChecks] : [];
                newSpotChecks.push(spotCheckCount + 1);
                setSpotChecks(newSpotChecks);
                */
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Adding Spot Check");
            });
    }

    function onRemoveSpotCheckClick() {

        /*
        let newSpotChecks = [...spotChecks];

        newSpotChecks.pop();

        setSpotChecks(newSpotChecks);
        */
    }

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && benchSheet) {
            const bs = benchSheet as any;
            const currentValue = bs[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                setBenchSheet({ ...benchSheet, [caller]: e.value });

                let fieldUpdate: FieldUpdate = {
                    entity: "TurbidityBenchSheets",
                    field: caller,
                    value: e.value,
                    rowId: benchSheetId
                };

                await updateField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Field");
                    });
            }
        }
    }
    async function onSpotCheckValueChanged(e: any) {
        //console.log("onSpotCheckValueChanged.....")

        if (!dataLoaded)
            return;

        const indexedCaller = e.element.id as string;

        if (!indexedCaller.includes("_"))
            return;

        const undIdx = indexedCaller.indexOf('_');
        const spotCheckSequence = parseInt(indexedCaller.substring(undIdx + 1));
        const caller = indexedCaller.substring(0, undIdx);

        let currentSpotCheckBenchSheets = [...spotCheckBenchSheets];
        let selectedSpotCheckBenchSheet = currentSpotCheckBenchSheets.find(s => s.sequence === spotCheckSequence);

        if (selectedSpotCheckBenchSheet) {
            const currentValue = selectedSpotCheckBenchSheet[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                selectedSpotCheckBenchSheet[caller] = e.value;

                setSpotCheckBenchSheets(currentSpotCheckBenchSheets);

                let fieldUpdate: FieldUpdate = {
                    entity: "SpotCheckBenchSheets",
                    field: caller,
                    value: e.value,
                    rowId: selectedSpotCheckBenchSheet.benchSheetId
                };

                await updateField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Field");
                    });
            }
        }
    }

    //GET functions

    async function getBenchSheet() {
        await CrudFunctions.getData(`benchsheets/benchsheet/${benchSheetId}`)
            .then(data => {
                setBenchSheet(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet");
            });
    }

    async function getSpotCheckBenchSheets() {
        await CrudFunctions.getData(`benchsheets/spotcheckbenchsheets/${benchSheetId}`)
            .then(data => {
                setSpotCheckBenchSheets(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Spot Checks");
            });
    }

    // POST functions

    async function insertSpotCheckBenchSheet(spotCheckBenchSheet: SpotCheckBenchSheet) {
        return CrudFunctions.postData("benchsheets/spotcheckbenchsheet", spotCheckBenchSheet);
    }

    // PUT functions

    async function updateField(fieldUpdate: FieldUpdate) {
        return CrudFunctions.putData("benchsheets/turbiditybenchsheetfield", fieldUpdate);
    }

    // other functions

    async function getAllData() {
        await Promise.all([
            getBenchSheet(),
            getSpotCheckBenchSheets()
        ])
            .then(() => setDataLoaded(true));
    }

    function showTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(true);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function showBenchSheetInformationDialog() {
        if (benchSheet) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: benchSheet.benchSheetId,
                createTimestamp: benchSheet.createTimestamp,
                lastModifiedTimestamp: benchSheet.modifyTimestamp,
                createUser: benchSheet.createUser,
                modifyUser: benchSheet.modifyUser
            };

            setItemBasicInformation(itemInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function onPanelButtonClick(e: any) {
        if (e.target && e.target.id)
            setCurrentTab(e.target.id);

        resetAllButtons();

        const button = e.target as HTMLDivElement;

        if (button) {
            button.className = "tab-button-active";
        }

        hideAllComponents();

        const id: string = e.target.id;
        const panel = document.getElementById(id.replace("Button", "")) as HTMLDivElement;
        panel.style.display = "";
    }

    function resetAllButtons() {
        const qcPanelButton = document.getElementById("qcPanelButton") as HTMLDivElement;
        qcPanelButton.className = "tab-button-inactive";

        if (spotCheckBenchSheets) {
            spotCheckBenchSheets.forEach(sc => {
                const spotCheckButton = document.getElementById(`spotCheckPanelButton${sc.sequence}`) as HTMLDivElement;
                if (spotCheckButton)
                    spotCheckButton.className = "tab-button-inactive";
            });
        }
    }

    function hideAllComponents(onload: boolean = false) {
        if (!onload) {
            const qcPanel = document.getElementById("qcPanel") as HTMLDivElement;
            qcPanel.style.display = "none";
        }

        if (spotCheckBenchSheets) {
            spotCheckBenchSheets.forEach(sc => {
                const spotCheckPanel = document.getElementById(`spotCheckPanel${sc.sequence}`) as HTMLDivElement;
                if (spotCheckPanel)
                    spotCheckPanel.style.display = "none";
            });
        }
    }

    function initTabs() {
        hideAllComponents(true);

        const qcPanelTab = document.getElementById(currentTab ? currentTab : "qcPanelButton") as HTMLDivElement;
        qcPanelTab.click();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
